import React from 'react';
import { Link } from 'react-router-dom';
import { FaLock, FaArrowLeft } from 'react-icons/fa';

const Forbidden = () => {
  // localStorage'dan kullanıcı rolünü al
  const userRole = localStorage.getItem("userRole") || "user";
  
  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-b from-gray-900 to-indigo-900 text-white">
      <div className="text-center p-8 max-w-md bg-gray-800 bg-opacity-50 rounded-lg shadow-2xl">
        <div className="w-20 h-20 mx-auto bg-red-600 rounded-full flex items-center justify-center mb-6">
          <FaLock className="text-4xl" />
        </div>
        
        <h1 className="text-3xl font-bold mb-4">Erişim Engellendi</h1>
        <p className="mb-8 text-gray-300">
          Bu sayfaya erişmek için gerekli yetkiniz bulunmamaktadır. 
          {userRole === "user" ? (
            <span> Lütfen yönetici ile iletişime geçin.</span>
          ) : (
            <span> Lütfen giriş yapın veya farklı bir hesapla deneyin.</span>
          )}
        </p>
        
        <div className="flex justify-center space-x-4">
          <Link
            to={userRole === "admin" ? "/dashboard" : "/student-list"}
            className="px-6 py-3 bg-indigo-600 hover:bg-indigo-700 rounded-lg shadow-md transition-colors duration-300 flex items-center"
          >
            <FaArrowLeft className="mr-2" />
            {userRole === "admin" ? "Panele Dön" : "Öğrenci Listesine Dön"}
          </Link>
          
          <Link
            to="/"
            className="px-6 py-3 bg-purple-600 hover:bg-purple-700 rounded-lg shadow-md transition-colors duration-300"
          >
            Ana Sayfaya Dön
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Forbidden; 